/** @format */
import { Market, OperationFixture } from '@toucan/config/markets';

import { client } from '@toucan/services/request-client';

export async function getOperations() {
    const { data } = await client.get<{ operations: OperationFixture[] }>(
        '/fixtures/operations'
    );

    return data;
}

export async function getMarkets() {
    const { data } = await client.get<{ markets: Market[] }>(
        '/fixtures/markets'
    );

    return data;
}
